import { render } from "./ReviewRating.vue?vue&type=template&id=3b6f5b1c&scoped=true"
import script from "./ReviewRating.vue?vue&type=script&lang=js"
export * from "./ReviewRating.vue?vue&type=script&lang=js"

import "./ReviewRating.vue?vue&type=style&index=0&id=3b6f5b1c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6f5b1c"]])

export default __exports__